import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, mergeMap } from 'rxjs/operators';
import { AppStore } from 'src/app/store/store.model';
import { SetUserApiError } from 'src/app/store/user/user.actions';
import { UserApiError, UserApiErrorTypes } from 'src/app/store/user/user.errors';
import { isUserLoaded, isAdmin } from 'src/app/store/user/user.selectors';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  public isAdmin$ = this.store.select(isAdmin);
  public isUserLoaded$ = this.store.select(isUserLoaded);

  constructor(private router: Router, private store: Store<AppStore>) {}

  public canActivate() {
    return this.isUserLoaded$.pipe(
      filter(Boolean),
      mergeMap(() => this.isAdmin$),
      map((isAdminUser) => {
        if (!isAdminUser) {
          this.store.dispatch(
            SetUserApiError({
              error: new UserApiError(UserApiErrorTypes.PermissionsError, new Error()),
            }),
          );

          this.router.navigate(['/dashboard']);
          return false;
        }

        return true;
      }),
    );
  }

  public canActivateChild() {
    return this.canActivate();
  }
}
